import Code from './Code.component';
import CodeTextMode from './displayMode/TextMode.component';

export { CodeTextMode };
export default Code;
